export const resources = {
  resourcesFolderInfoText: 'Archivo(s)',
  resourcesItemInfoLastUpdText: 'Última actualización',
  resourcesItemInfoUploadedText: 'Subido',
  resourcesSearchInputText: 'Buscar',
  resourcesUserActionSheetOptionTitle: 'Copiar enlace',
  resourcesActionCopiedAlertText: 'Enlace copiado!',
  resourcesOwnersCurtainEditOptionText: 'Editar título',
  resourcesOwnersCurtainDeleteOptionText: 'Eliminar',
  resourcesOwnerCurtainHideOptionText: 'Ocultar (Inactivo)',
  resourcesEditPopupTitle: 'Editar título',
  resourcesEditPopupResetButtonTitle: 'Restablecer',
  resourcesEditPopupApplyButtonTitle: 'Aplicar',
  resourcesItemEditedAlertText: '¡El elemento se actualizó correctamente!',
  resourcesHidePopupTitle: 'Ocultar',
  resourcesHidePopupText: '¿Ocultar este elemento?',
  resourcesHidePopupCancelButtonTitle: 'Cancelar',
  resourcesHidePopupConfirmButtonTitle: 'Confirmar',
  resourcesDeletePopupTitle: 'Eliminar',
  resourcesDeletePopupText: '¿Eliminar este elemento?',
  resourcesDeletePopupCancelButtonTitle: 'Cancelar',
  resourcesDeletePopupConfirmButtonTitle: 'Confirmar',
  resourcesItemDeletedAlertText: '¡El elemento se eliminó correctamente!',
  resourceDetailsLinkText: 'Este es un URL externo y se abrirá en una nueva ventana. ¿Abrir?',
  resourceDetailsLinkOpenButtonTitle: 'Abrir',
  resourceDetailsLinkOpenAgainButtonTitle: 'Abrir de nuevo',
  resourceDetailsLinkCopyURLButtonTitle: 'Copiar URL de destino',
  resourceDetailsLinkCopiedURLAlertText: '¡URL copiado!',
  resurceDetailsLinkCurtainOptionCopyText: 'Copiar enlace',
  resourceDetailsFileInfoLastUpdText: 'Última actualización',
  resourceDetailsFileInfoUploadText: 'Subido',
  resourceDetailsFileSaveButtonTitle: 'Abrir',
  resourceDetailsFileCopyButtonTitle: 'Copiar enlace',
  resourcesOwnersCurtainCopyOptionText: 'Copiar enlace',
  resourceDetailsFileLoadingText: 'Cargando...',
  resourceDetailsImageCurtainCopyOptionText: 'Copiar enlace',
  resourceDetailsImageCurtainDownloadOptionText: 'Descargar',
  resourceFolder: 'Carpeta',
  resourceAdded: 'Añadido'
}
